/**
 * Created by Mark on 23/11/2016.
 */

import ENVIRONMENT_CONSTANTS from './environment.js'

export default {
    GET_WORDS_LEARNT_ACCOUNT_LEVEL: ENVIRONMENT_CONSTANTS.BASE_URL + '/wordsLearntController/getWordsLearnt',
    GET_WORDS_TOTAL_ACCOUNT: ENVIRONMENT_CONSTANTS.BASE_URL + '/wordsLearntController/getTotalWordsLearnt',
    GET_WORDS_TOTAL_CLASS: ENVIRONMENT_CONSTANTS.BASE_URL + '/wordsLearntController/getWordsLearntBySkillForClass',
    UPDATE_ACCOUNT_LEVEL: 'UPDATE_ACCOUNT_LEVEL',
    UPDATE_ACCOUNT_TOTAL: 'UPDATE_ACCOUNT_LEVEL_TOTAL',
    UPDATE_CLASS_TOTAL: 'UPDATE_CLASS_LEVEL_TOTAL',
    UPDATE_ACCOUNT_LEVEL_SKILLS: 'UPDATE_ACCOUNT_LEVEL_SKILLS',
    GET_WORDS_TOTAL_STUDENT:  ENVIRONMENT_CONSTANTS.BASE_URL + '/wordsLearntController/getWordsLearntBySkillForStudent',
    UPDATE_STUDENT_TOTAL: 'UPDATE_STUDENT_TOTAL',
    GET_CLASS_TOTAL  :ENVIRONMENT_CONSTANTS.BASE_URL + '/wordsLearntController/getTotalClassWordsLearnt',
    GET_STUDENT_TOTAL:ENVIRONMENT_CONSTANTS.BASE_URL + '/wordsLearntController/getTotalStudentWordsLearnt',
    UPDATE_CLASS_WORDS_TOTAL :"UPDATE_CLASS_TOTAL",
    UPDATE_STUDENT_WORDS_TOTAL:"UPDATE_STUDENT_WORDS_TOTAL"
}


// WEBPACK FOOTER //
// ./src/constants/words-learnt.js